import { render } from "./CoffeeWriter.vue?vue&type=template&id=90b8ec38"
import script from "./CoffeeWriter.vue?vue&type=script&lang=js"
export * from "./CoffeeWriter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__